import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=0f76064c"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f76064c')) {
      api.createRecord('0f76064c', component.options)
    } else {
      api.reload('0f76064c', component.options)
    }
    module.hot.accept("./transfer.vue?vue&type=template&id=0f76064c", function () {
      api.rerender('0f76064c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesman/staffManage/transfer.vue"
export default component.exports